import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import BusinessHeader from './components/BusinessHeader';
import PhotoGallery from './components/PhotoGallery';
import BusinessInformation from './components/BusinessInformation';
import ContentFeed from './components/ContentFeed';
import ReviewsSection from './components/ReviewsSection';
import QRInstructions from './components/QRInstructions';

const BusinessProfile = () => {
  const navigate = useNavigate();
  const [currentUser] = useState({
    type: "user",
    membershipTier: "Emprendedor",
    notifications: {
      dashboard: 3,
      affiliate: 1
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const businessData = {
    id: "biz_001",
    name: "Café Aroma Colombiano",
    category: "Restaurantes y Cafeterías",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1250e85be-1766879481924.png",
    logoAlt: "Logo de Café Aroma Colombiano mostrando taza de café humeante con granos de café colombiano en fondo cálido",
    discountPercentage: 15,
    rating: 4.8,
    reviewCount: 127,
    address: "Calle 18 #25-40, Pasto",
    fullAddress: "Calle 18 #25-40, Centro, Pasto, Nariño, Colombia",
    phone: "+57 312 456 7890",
    email: "contacto@aromacolombia.co",
    whatsapp: "573124567890",
    whatsappDisplay: "+57 312 456 7890",
    hours: "Lun-Sáb: 7:00 AM - 9:00 PM",
    qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=BIZZNET_BIZ001",
    coordinates: {
      lat: 1.2136,
      lng: -77.2811
    },
    description: "Café Aroma Colombiano es un espacio acogedor donde celebramos la rica tradición cafetera de Colombia. Ofrecemos café de origen 100% colombiano, preparado con métodos artesanales que resaltan los sabores únicos de nuestra tierra. Nuestro menú incluye desayunos tradicionales, almuerzos ejecutivos y una variedad de postres caseros. Cada taza cuenta una historia de las montañas de Nariño, donde se cultivan los mejores granos de café del mundo.",
    operatingHours: [
    { day: "Lunes - Viernes", hours: "7:00 AM - 9:00 PM" },
    { day: "Sábado", hours: "8:00 AM - 10:00 PM" },
    { day: "Domingo", hours: "8:00 AM - 8:00 PM" },
    { day: "Festivos", hours: "9:00 AM - 6:00 PM" }],

    socialMedia: {
      facebook: "https://facebook.com/aromacolombia",
      instagram: "https://instagram.com/aromacolombia",
      website: "https://aromacolombia.co"
    },
    images: [
    {
      url: "https://images.unsplash.com/photo-1713513872117-ac8b958f73c6",
      alt: "Interior acogedor de Café Aroma Colombiano con mesas de madera, sillas vintage y decoración rústica colombiana con plantas colgantes"
    },
    {
      url: "https://images.unsplash.com/photo-1579546937949-2f37293c1ea3",
      alt: "Taza de café colombiano recién preparado con arte latte en forma de corazón sobre mesa de madera con granos de café esparcidos"
    },
    {
      url: "https://images.unsplash.com/photo-1583038298564-63a3b548e5a7",
      alt: "Desayuno tradicional colombiano con huevos revueltos, arepa, queso fresco y café servido en vajilla artesanal"
    },
    {
      url: "https://images.unsplash.com/photo-1599579844009-768de39639eb",
      alt: "Barista profesional preparando café con método de goteo en cafetera de vidrio con granos colombianos premium"
    },
    {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_1fac44f6a-1768527689004.png",
      alt: "Variedad de postres caseros colombianos incluyendo tres leches, arequipe y torta de café en vitrina iluminada"
    }],

    posts: [
    {
      id: "post_001",
      type: "image",
      mediaUrl: "https://images.unsplash.com/photo-1589688985167-201b68e95389",
      mediaAlt: "Promoción especial de café colombiano con croissant recién horneado y jugo de naranja natural en mesa de madera rústica",
      caption: "¡Nueva promoción de desayuno! Café colombiano + Croissant + Jugo natural por solo $12.000 COP. Válido de lunes a viernes de 7:00 AM a 10:00 AM. ☕🥐",
      likes: 89,
      comments: [
      {
        id: "com_001",
        author: "María González",
        text: "¡Excelente promoción! Ya quiero probarla mañana 😍",
        timestamp: new Date(Date.now() - 7200000)
      },
      {
        id: "com_002",
        author: "Carlos Ramírez",
        text: "El mejor café de Pasto, sin duda. Siempre vuelvo por más ☕",
        timestamp: new Date(Date.now() - 3600000)
      }],

      timestamp: new Date(Date.now() - 86400000)
    },
    {
      id: "post_002",
      type: "video",
      mediaUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
      mediaAlt: "Video mostrando el proceso artesanal de preparación de café colombiano desde la molienda de granos hasta el servido en taza",
      caption: "Así preparamos cada taza de café en Aroma Colombiano. Proceso 100% artesanal con amor y dedicación. 🇨🇴☕",
      likes: 156,
      comments: [
      {
        id: "com_003",
        author: "Ana Martínez",
        text: "Me encanta ver el proceso, se nota la calidad y el cuidado 👏",
        timestamp: new Date(Date.now() - 1800000)
      }],

      timestamp: new Date(Date.now() - 172800000)
    },
    {
      id: "post_003",
      type: "image",
      mediaUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1568c8f43-1765386842882.png",
      mediaAlt: "Almuerzo ejecutivo colombiano con bandeja paisa, arroz, frijoles, carne asada, aguacate y plátano maduro en plato tradicional",
      caption: "Nuestro almuerzo ejecutivo incluye: Sopa del día, plato fuerte, jugo natural y postre. Todo por $18.000 COP. Disponible de 12:00 PM a 3:00 PM 🍽️",
      likes: 134,
      comments: [
      {
        id: "com_004",
        author: "Luis Hernández",
        text: "La mejor relación calidad-precio de la zona. Muy recomendado 👍",
        timestamp: new Date(Date.now() - 900000)
      },
      {
        id: "com_005",
        author: "Patricia Silva",
        text: "Delicioso como siempre. El postre de tres leches es mi favorito 😋",
        timestamp: new Date(Date.now() - 600000)
      }],

      timestamp: new Date(Date.now() - 259200000)
    }],

    reviews: [
    {
      id: "rev_001",
      userName: "Sofía Rodríguez",
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
      userAvatarAlt: "Foto de perfil de mujer joven con cabello castaño largo y sonrisa amigable en fondo neutro",
      rating: 5,
      comment: "Excelente lugar para disfrutar de un buen café colombiano. El ambiente es muy acogedor y el servicio es impecable. Los precios son justos y la calidad es excepcional. Definitivamente volveré y lo recomiendo a todos los amantes del café.",
      date: new Date(Date.now() - 604800000),
      helpful: 23
    },
    {
      id: "rev_002",
      userName: "Diego Morales",
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1af6f2c00-1763296463763.png",
      userAvatarAlt: "Foto de perfil de hombre adulto con barba corta, gafas y camisa casual en ambiente profesional",
      rating: 5,
      comment: "El mejor café de Pasto sin lugar a dudas. La atención es personalizada y siempre te hacen sentir como en casa. Los desayunos son deliciosos y abundantes. El descuento de BIZZNET hace que sea aún mejor.",
      date: new Date(Date.now() - 1209600000),
      helpful: 18
    },
    {
      id: "rev_003",
      userName: "Valentina Castro",
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_155101c03-1763301787020.png",
      userAvatarAlt: "Foto de perfil de mujer joven con cabello negro corto, maquillaje natural y expresión alegre",
      rating: 4,
      comment: "Muy buen lugar, el café es delicioso y los postres caseros son increíbles. El único detalle es que a veces hay que esperar un poco en horas pico, pero vale totalmente la pena. Recomendado 100%.",
      date: new Date(Date.now() - 1814400000),
      helpful: 12
    },
    {
      id: "rev_004",
      userName: "Andrés Gutiérrez",
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_127e9981c-1763294845290.png",
      userAvatarAlt: "Foto de perfil de hombre joven con cabello corto oscuro, sonrisa amplia y vestimenta casual deportiva",
      rating: 5,
      comment: "Lugar perfecto para trabajar o estudiar. Tienen WiFi rápido, enchufes en todas las mesas y el café es excelente. El ambiente es tranquilo y la música de fondo es perfecta. Vengo casi todos los días.",
      date: new Date(Date.now() - 2419200000),
      helpful: 15
    },
    {
      id: "rev_005",
      userName: "Carolina Pérez",
      userAvatar: "https://images.unsplash.com/photo-1677107792780-166cf9dcd690",
      userAvatarAlt: "Foto de perfil de mujer adulta con cabello rubio ondulado, lentes de sol y estilo elegante",
      rating: 5,
      comment: "Simplemente perfecto. Desde que entras te reciben con una sonrisa. El café es de la mejor calidad y los almuerzos ejecutivos son muy completos. Los precios son muy razonables considerando la calidad que ofrecen.",
      date: new Date(Date.now() - 3024000000),
      helpful: 20
    }],

    discountTerms: [
    "Válido solo para miembros activos de BIZZNET con membresía vigente",
    "El descuento aplica sobre el total de la compra antes de impuestos",
    "No acumulable con otras promociones o descuentos del establecimiento",
    "Debe presentar el código QR antes de realizar el pago",
    "Un uso por visita, sin límite de visitas mensuales",
    "El negocio se reserva el derecho de verificar la autenticidad del código QR",
    "Descuento aplicable en todos los productos y servicios del menú",
    "No aplica para compras de gift cards o certificados de regalo"]

  };

  const handleScanQR = () => {
    console.log("QR Code scanned for business:", businessData?.id);
  };

  const handleWhatsApp = () => {
    console.log("WhatsApp contact initiated for business:", businessData?.id);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={currentUser} />
      <NavigationBreadcrumbs businessName={businessData?.name} />
      <main className="main-content max-w-7xl mx-auto pb-12">
        <BusinessHeader
          business={businessData}
          onScanQR={handleScanQR}
          onWhatsApp={handleWhatsApp} />


        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <PhotoGallery images={businessData?.images} />
            <ContentFeed posts={businessData?.posts} businessName={businessData?.name} />
            <ReviewsSection
              reviews={businessData?.reviews}
              averageRating={businessData?.rating}
              totalReviews={businessData?.reviewCount} />

          </div>

          <div className="lg:col-span-1">
            <BusinessInformation business={businessData} />
            <QRInstructions
              discountPercentage={businessData?.discountPercentage}
              terms={businessData?.discountTerms} />

          </div>
        </div>
      </main>
    </div>);

};

export default BusinessProfile;